import React from "react";
import {
  Input,
  Label,
  Form,
  Title,
  InputGroup,
  LabelRequired,
} from "styles/common/FormStyle";
import { CommonWrapper, Background } from "styles/common/Layout";
import { ButtonOutline } from "styles/common/ButtonStyle";
import useAuthStore from "store/auth";
import { useState } from "react";
import { updateUser } from "api/user";
import { useNavigate } from "react-router-dom";
import useModalStore from "store/modal";
import DaumPostcode from "react-daum-postcode";

const EditUserInfo = () => {
  const authStore = useAuthStore();
  const modalStore = useModalStore();
  const navigate = useNavigate();
  const userInfo = authStore?.user;

  const [form, setForm] = useState({
    name: userInfo?.alias,
    address: userInfo?.addr,
    postNo: userInfo?.postno,
    aptName: userInfo?.aptname,
    addressDetail: userInfo?.addrdetail,
  });

  const handleChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const searchAddress = () => {
    modalStore.openModal({
      title: "주소 검색",
      content: <DaumPostcode onComplete={handleComplete} />,
    });
  };

  const handleComplete = (data) => {
    setForm({
      ...form,
      postNo: data.zonecode,
      address: data.roadAddress || data.autoRoadAddress || data.address,
      aptName: data.apartment ? data.buildingName : "",
      addressDetail: "",
    });
    modalStore.closeModal();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const newUserInfo = {
      alias: form.name,
      address: form.address,
      postno: form.postNo,
      aptname: form.aptName,
      addrdetail: form.addressDetail,
    };

    try {
      await updateUser(form);
      authStore.setUser({ ...userInfo, ...newUserInfo });
      alert("회원정보가 수정되었습니다.");
      navigate("/");
    } catch (error) {
      alert(error);
    }
  };

  return (
    <Background>
      <CommonWrapper>
        <Form onSubmit={handleSubmit} id="contents">
          <Title>회원정보 수정</Title>
          <LabelRequired htmlFor="name">이름</LabelRequired>
          <Input
            type="name"
            id="name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
          <Label htmlFor="address">주소</Label>
          <InputGroup>
            <Input
              type="postNo"
              id="postNo"
              name="postNo"
              value={form.postNo}
              onChange={handleChange}
              placeholder="우편번호"
              disabled
            />
            <ButtonOutline
              type="button"
              width="120px"
              height="40px"
              margin="0 0 0 10px"
              onClick={searchAddress}
            >
              주소 검색
            </ButtonOutline>
          </InputGroup>
          <Input
            type="text"
            id="address"
            name="address"
            value={form.address}
            onChange={handleChange}
            placeholder="주소"
            disabled
          />
          <Input
            type="text"
            id="addressDetail"
            name="addressDetail"
            value={form.addressDetail}
            onChange={handleChange}
            placeholder="상세주소"
          />
          <ButtonOutline type="submit">수정</ButtonOutline>
        </Form>
      </CommonWrapper>
    </Background>
  );
};

export default EditUserInfo;
